// resources/js/calculator/validation.js
// Pure per-step validators for the Obrotomat calculator (CALC-08).
// validateStep(step, state) → errors object; empty object ({}) means the step is valid.
// No Alpine imports — composed into the obrCalc component by state.js and unit-testable in isolation.
// PL error copy is locked from 03-UI-SPEC.md (Copywriting Contract, lines 330-332).

/**
 * Validate a single calculator step against the current component state.
 *
 * @param {number} step  1 (turnover) | 2 (tenure) | 3 (industry)
 * @param {{turnover?: number, tenure?: string|null, industry?: string|null}} s  component state slice
 * @returns {Object} errors keyed by field ({} = valid)
 */
export function validateStep(step, s) {
  if (step === 1) {
    if (!s.turnover || s.turnover < 10000 || s.turnover > 2000000) {
      return { turnover: 'Podaj kwotę od 10 000 zł do 2 000 000 zł.' }
    }
  }
  if (step === 2 && s.tenure === null) {
    return { tenure: 'Wybierz, od kiedy firma przyjmuje płatności kartą.' }
  }
  if (step === 3 && s.industry === null) {
    return { industry: 'Wybierz branżę swojej firmy.' }
  }
  return {}
}

/**
 * Validate the Phase-6 phone form (LEAD-01/02) — the client mirror of the server gate.
 * Phone must be 9 digits (first non-zero); consent_call is required; consent_sms is optional
 * (never validated). Returns the first failing field only ("one message at a time", 06-UI-SPEC).
 *
 * @param {{phoneDigits?: string, consentCall?: boolean}} s  component state slice
 * @returns {Object} errors keyed by field ({} = valid)
 */
export function validateForm(s) {
  if (!/^[1-9]\d{8}$/.test(s.phoneDigits)) {
    return { phone: 'Podaj poprawny numer telefonu (9 cyfr).' }
  }
  if (s.consentCall !== true) {
    return { consent_call: 'Zaznacz zgodę na kontakt telefoniczny, aby wysłać zgłoszenie.' }
  }
  return {}
}
